import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RsvpComponent } from '../rsvp/rsvp.component';
import { DatesService } from '../../services/dates.service';
import { DateRangePipe, StageTitlePipe } from '../../shared';
import { isTripOwner } from '../../../../shared';
import { CURRENT_TRIP } from '../../../../services';
import { RouterLink } from '@angular/router';
import { AvailabilityPickerComponent } from '../availability-picker/availability-picker.component';

@Component({
  selector: 'at-dates-tile',
  standalone: true,
  imports: [RsvpComponent, DateRangePipe, StageTitlePipe, RouterLink, AvailabilityPickerComponent, RsvpComponent],
  templateUrl: './dates-tile.component.html',
  styleUrl: './dates-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'summary-card dates-card',
  },
})
export class DatesTileComponent {
  private readonly datesService = inject(DatesService);
  private readonly trip = inject(CURRENT_TRIP);

  protected readonly state = this.datesService.datesSummary;

  protected readonly stage = computed(() => {
    return this.state()?.data?.state;
  });

  protected readonly locked = computed(() => {
    return this.state()?.data?.locked;
  });

  protected readonly isOwner = isTripOwner();

  protected editLink = computed(() => {
    const stage = this.stage();
    if (!stage) return undefined;

    if (stage === 'NotStarted') return ['/', 'trip', this.trip.tripId(), 'dates', 'edit', 'flow'];

    const editStage = stage === 'GatheringAvailability' ? 'range' : 'dates';
    if (!editStage) return undefined;

    return ['/', 'trip', this.trip.tripId(), 'dates', 'edit', editStage];
  });
}
